import React from "react";
import PostAnalysisMultiSelectDropdown from "@/components/ui/PostAnalysisMultiSelectDropdown";

// Thin wrapper around the shared PostAnalysisMultiSelectDropdown to avoid duplicated logic.
const MultiSelectDropdown = (props) => {
  return (
    <PostAnalysisMultiSelectDropdown
      {...props}
      // For generic filters we want immediate application, not apply-on-close batching.
      applyOnClose={false}
    />
  );
};

export default MultiSelectDropdown;